import { ReportItem as ReportItemType } from '../../../types/conversation';
import ReportRenderer from '../../ReportRenderer';

interface ReportItemProps {
  item: ReportItemType;
}

export function ReportItem({ item }: ReportItemProps) {
  return (
    <div className="flex justify-start">
      <div className="max-w-[95%] w-full">
        <div className="bg-white dark:bg-slate-800 rounded-2xl rounded-tl-sm border border-slate-200 dark:border-slate-700 p-4">
          <ReportRenderer markdown={item.markdown} />
        </div>
      </div>
    </div>
  );
}

export default ReportItem;
